import fi from 'todistukset-common/src/vtj/static/localization_fi.json'
import en from 'todistukset-common/src/vtj/static/localization_en.json'
import sv from 'todistukset-common/src/vtj/static/localization_sv.json'

const translations = {
  fi,
  en,
  sv,
}

export default {
  namespace: 'todistukset-common',
  translations,
}
